module.exports = __webpack_public_path__ + "app-static/img/p_04.e734d74e.jpg";